import { useLocation } from 'react-router-dom';

import { useWorkspaceForGroup } from '@/hooks/useWorkspaceForGroup';
import { useWorkspaceForTrace } from '@/hooks/useWorkspaceForTrace';
import { useWorkspaceForWorkflow } from '@/hooks/useWorkspaceForWorkflow';

// All workflow-scoped routes start with `/workflow/<id>` (overview, export,
// newlink, settings/groups), so the first segment is always the workflow id.
const WORKFLOW_PATH = /^\/workflow\/([^/]+)/;
const GROUP_PATH = /^\/group\/([^/]+)/;
const TRACE_PATH = /^\/trace\/([^/]+)/;

// Resolves the workspace for the current route from the URL, covering every
// workspace-scoped page (workflow, group and trace). Also reports whether the
// route is workspace-scoped at all and whether the lookup is still loading, so
// callers can distinguish "production workflow (no workspace)" from "loading"
// and from "not a workspace route". Used by the screen border and the navbar.
export const useRouteWorkspace = () => {
  const { pathname } = useLocation();
  const workflowId = pathname.match(WORKFLOW_PATH)?.[1] ?? '';
  const groupId = pathname.match(GROUP_PATH)?.[1] ?? '';
  const traceId = pathname.match(TRACE_PATH)?.[1] ?? '';

  const workflow = useWorkspaceForWorkflow(workflowId);
  const group = useWorkspaceForGroup(groupId);
  const trace = useWorkspaceForTrace(traceId);

  return {
    workspace: workflow.workspace ?? group.workspace ?? trace.workspace ?? null,
    isWorkspaceRoute: Boolean(workflowId || groupId || traceId),
    loading: workflow.loading || group.loading || trace.loading,
    error: workflow.error || group.error || trace.error
  };
};
